import { render } from "./carouselIndicator.vue?vue&type=template&id=8a42c06e"
import script from "./carouselIndicator.vue?vue&type=script&lang=js"
export * from "./carouselIndicator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__